import { AccessControl } from 'accesscontrol';
const ac = new AccessControl();

export const ACTIONS = {
	CREATE_OWN: 'createOwn',
	CREATE_ANY: 'createAny',

	READ_OWN: 'readOwn',
	READ_ANY: 'readAny',

	UPDATE_OWN: 'updateOwn',
	UPDATE_ANY: 'updateAny',

	DELETE_OWN: 'deleteOwn',
	DELETE_ANY: 'deleteAny',
};

export const RESOURCES = {
	PROFILE: 'PROFILE',

	// WAREHOUSE: {
	//     DASHBOARD: 'WAREHOUSE.DASHBOARD',
	//     GLOBAL_LEAD_TIME: 'WAREHOUSE.GLOBAL_LEAD_TIME',
	//     PACKING: {
	//         DOCUMENT: {
	//             TAGS: 'PACKING.DOCUMENT.TAGS'
	//         },
	//         ORDERS: {
	//             FULFILLMENT: 'WAREHOUSE.PACKING.ORDERS.FULFILLMENT',
	//         }
	//     },
	//     PICKING: {
	//         BIN_LOCATIONS: 'PICKING.BIN_LOCATIONS'
	//     },
	//     SHIPPING_METHODS: 'WAREHOUSE.SHIPPING_METHODS',
	// },

	// EXPERIMENTAL: {
	//     SUBSCRIPTIONS_TESTING: 'EXPERIMENTAL.SUBSCRIPTIONS_TESTING',
	// }
};

export const ROLES = {
	USER: 'USER',

	ADMIN: 'ADMIN',
	SUPER_ADMIN: 'SUPER_ADMIN',
};

export const ACCESS_CONTROL = (function () {
	ac.grant(ROLES.USER).resource(RESOURCES.PROFILE).readOwn(null, ['*', '!password']).updateOwn();

	//Admin
	ac.grant(ROLES.ADMIN).extend(ROLES.USER).resource(RESOURCES.PROFILE).createAny().readAny(null, ['*', '!password']).updateAny().deleteAny();

	//Experimental Flags
	// .resource(RESOURCES.EXPERIMENTAL.SUBSCRIPTIONS_TESTING).readAny()

	ac.grant(ROLES.SUPER_ADMIN).extend(ROLES.ADMIN);

	ac.lock();

	return ac;
})();
